import { createActionThunk } from "redux-thunk-actions";
import {
  GET_EDIT_SYMPTOM_USERS,
  SYMPTOM_SELECTED,
  GET_SYMPTOM_LIST,
  EDIT_SYMPTOM_CATEGORY_SELECTED,
  EDIT_PAGE_SEARCH_SYMPTOM_OPTIONS,
  SYMPTOM_DELETED,
  EDIT_SYMPTOM_DATE_CHANGED,
  EDIT_SYMPTOM_OPTION_SELECTED,
  UPDATE_SYMPTOM,
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  ON_CHANGE_SYMPTOMEDITFORM,
  ON_CHANGE_SEARCHFORM,
  SYMPTOM_SEARCH_DATE_CHANGED,
  RESET_EDIT_PAGE,
  ON_SAVE_PAGE_SYMPTOMEDITFORM,
  EDITSYMPTOM_CHANGER_SEARCHFORM,
  SYMPTOM_EXPORT,
  EDITSYMPTOM_BODYMAP_RETURN,
  EDITSYMPTOM_BODYMAP_START,
  EDITSYMPTOM_EXPORT_DATE_CHANGED,
  EDIT_PAGE_BARCODE_READ,
  EDIT_PAGE_BARCODE_READ_IMG,
  PARTIAL_RESULT_FOUND,
  CLEAR_EDIT_SYMPTOMS,
  ON_CHANGE_ALERT_STATUS,
  ADD_GREY_UPC_ITEM_NAME_FIELD,
  SET_HHMM_MODE,
  RESET_CONTRIBUTE_ALERT_STATE,
  DISMISS_EDIT_SAVE_SUCCESS,
  RESET_MODAL,
} from "./constant";

import {
  getSymptomResponseDetail as getSymptomResponseDetailService,
  getSymptomList as getSymptomListService,
  searchSymptom as searchSymptomService,
  deleteSymptom as deleteSymptomService,
  getSymptomDetail as getSymptomDetailService,
  updateSymptom as updateSymptomService,
  getCategories,
  getReport,
} from "../services/SymptomService";
import { getUser as getSymptomUsersService } from "../services/UserService";
import { getMeasurements } from "../services/LookupService";
import {
  barcodeService,
  getPartialResult,
} from "../services/AutocompleteService";
import { barcode, getBarcode } from "../services/ContributeService";

const editPageInitialization = createActionThunk(
  GET_EDIT_SYMPTOM_USERS,
  async (_id) => {
    let users = await getSymptomUsersService(_id);
    let categories = await getCategories(_id);
    return { users, categories };
  }
);
const getSymptomList = createActionThunk(GET_SYMPTOM_LIST, (val) =>
  getSymptomListService(val)
);

const searchNameOptions = (val, type, crossClicked, contributeRedirectionAlert) => {
  return async (dispatch) => {
    dispatch({
      type: EDIT_PAGE_SEARCH_SYMPTOM_OPTIONS,
      val: val,
      crossClicked,
      contributeRedirectionAlert
    });
  };
};

const categorySelected = (e) => {
  return (dispatch) => {
    dispatch({
      type: EDIT_SYMPTOM_CATEGORY_SELECTED,
      value: e.target.value,
    });
  };
};

const symptomSelected = (item, type, index) => {
  return async (dispatch) => {
    try {
      let units = [];
      dispatch({
        type: SYMPTOM_SELECTED,
        item: item,
        units: units,
        category: type,
        index: index,
      });
    } catch (e) {
      console.log(e);
    }
  };
};

const deleteSymptom = (vId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SYMPTOM_DELETED,
        vId,
      });
    } catch (e) {
      console.log(e);
    }
  };
};

const symptomExport = createActionThunk(SYMPTOM_EXPORT, (val) =>
  getReport(val)
);

const onDateChange = (val) => {
  return (dispatch) => {
    dispatch({
      type: EDIT_SYMPTOM_DATE_CHANGED,
      val: val,
    });
  };
};
const onDateChangeSearch = (val) => {
  return (dispatch) => {
    dispatch({
      type: SYMPTOM_SEARCH_DATE_CHANGED,
      val: val,
    });
  };
};
const symptomOptionSelected = (data, type) => {
  return async (dispatch) => {
    let units = [];
    dispatch({
      type: EDIT_SYMPTOM_OPTION_SELECTED,
      item: data,
      units: units,
    });
  };
};

const updateSymptom = (data, type, callback) => {
  return async (dispatch) => {
    dispatch({
      type: getSucceeded(UPDATE_SYMPTOM),
      newData: data,
    });
  };
};
const savePage = (data, type, callback) => {
  // Helper: build a backend-ready copy of one row
  const normalizeRowForBackend = (row) => {
    const hasUpd = row && row.status === 1 && row.updatedData;
    const cat    = String(hasUpd ? row.updatedData.category : row.category || "");
    // shallow copy row; deep-copy updatedData/meals[0] only when we touch them
    const out  = { ...row };
    const base = hasUpd ? (out.updatedData = { ...row.updatedData }) : out;

    if (cat === "02") {
      // FOOD: size/unitid live in meals[0]
      const meal0 = base.meals && base.meals[0] ? { ...base.meals[0] } : null;
      if (meal0) {
        const bu = meal0.backendUnit;
        const bs = meal0.backendScale;
        if (bu != null && bs != null && String(bs) !== "") {
          meal0.unitid = String(bu);
          meal0.size   = String(bs);
        }
        // 🔻 Drop helpers from payload
        delete base.backendUnit;
        delete base.backendScale;

        if (base.meals) {
          const rest = base.meals.slice(1);
          base.meals = [meal0, ...rest];
        }
      }
    } else {
      // NON-FOOD: flat object
      const bu = base.backendUnit;
      const bs = base.backendScale;
      if (bu != null && bs != null && String(bs) !== "") {
        base.unitid = String(bu);
        // base.unit   = String(bu); // harmless mirror if backend reads either
        if (cat === "01") {
          // Symptom severity
          base.severity = String(bs);
        } else {
          // Activity / PCP / Drug / Supp / Location → numeric value
          base.value = String(bs);
        }
      }
      // 🔻 Drop helpers from payload
      delete base.backendUnit;
      delete base.backendScale;
    }
    // Extra-safe cleanup in case helpers existed elsewhere on the row:
    delete out.backendUnit;
    delete out.backendScale;
    if (Array.isArray(out.meals) && out.meals[0]) {
      delete out.meals[0].backendUnit;
      delete out.meals[0].backendScale;
    }

    return out;
  };

  return async (dispatch) => {
    dispatch({
      type: getStarted(ON_SAVE_PAGE_SYMPTOMEDITFORM),
    });

    // Build backend-ready copy (does NOT mutate Redux state)
    const payload = Array.isArray(data) ? data.map(normalizeRowForBackend) : data;

    try {
      let response = await updateSymptomService(payload, type, callback);

      dispatch({
        type: ON_SAVE_PAGE_SYMPTOMEDITFORM,
        data: response, // needed so reducer can read response.trend_alert
      });
      
    } catch (e) {
      dispatch({
        type: getFailed(ON_SAVE_PAGE_SYMPTOMEDITFORM),
        error: {
          message: typeof e === "string" ? e : (e && e.message),
          meta: (e && e.meta) || [],
        },
      });
    }
  };
};
const onChangeSyptomEditForm = (e) => {
  return (dispatch) => {
    dispatch({
      type: ON_CHANGE_SYMPTOMEDITFORM,
      event: e,
    });
  };
};
const onChangeSearchForm = (e) => {
  return (dispatch) => {
    dispatch({
      type: ON_CHANGE_SEARCHFORM,
      event: e,
    });
  };
};
const resetPage = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_EDIT_PAGE,
    });
  };
};
const searchFormChanger = (name, val) => {
  return (dispatch) => {
    dispatch({
      type: EDITSYMPTOM_CHANGER_SEARCHFORM,
      name: name,
      val: val,
    });
  };
};

const bodyMapReturn = () => {
  return async (dispatch) => {
    dispatch({
      type: getStarted(EDITSYMPTOM_BODYMAP_RETURN),
    });
    dispatch({
      type: getSucceeded(EDITSYMPTOM_BODYMAP_RETURN),
    });
    let units = [];
    let bodySymptom = localStorage.getItem("bodyMapSymptom");
    if (bodySymptom !== "cancel") {
      bodySymptom = JSON.parse(bodySymptom);
      dispatch({
        type: EDIT_SYMPTOM_OPTION_SELECTED,
        item: bodySymptom,
        units: units,
      });
    }

    dispatch({
      type: getEnded(EDITSYMPTOM_BODYMAP_RETURN),
    });
  };
};

const bodyMapStart = createActionThunk(EDITSYMPTOM_BODYMAP_START, () => {
  return "Hi";
});

const exportDateChanges = (val) => {
  return (dispatch) => {
    dispatch({
      type: EDITSYMPTOM_EXPORT_DATE_CHANGED,
      val: val,
    });
  };
};
export const barcodeSearch = (val, cat, partial, preloadedData = null) => {
  return async (dispatch) => {
    let category = cat ? cat : "02";

    dispatch({
      type: getStarted(EDIT_PAGE_BARCODE_READ),
    });
    try {
      if (partial) {
        let data = preloadedData ? preloadedData : await barcodeService(val, cat);
        if (data.message) {
          alert(data.message);
        } else {
          data = data;
        }
        const needsMealDetail =
          ([cat].includes(data.category) &&
            (data.is_ref ||
              (!data.is_ref &&
                ((!data.is_own &&
                  !data.is_history &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt) ||
                  (data.is_own &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt) ||
                  (data.is_history &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt))))) ||
          (!data.is_ref &&
            ((!data.is_own &&
              data.is_history &&
              data.number_of_contribute >= 4 &&
              !data.show_prompt) ||
              (data.is_own &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt) ||
              (data.is_history &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt)));
        dispatch({
          type: getSucceeded(EDIT_PAGE_BARCODE_READ),
          data: data,
        });

        if (needsMealDetail) {
          dispatch({
            type: EDIT_SYMPTOM_OPTION_SELECTED,
            item: data,
          });
        }
      } else {
        let data;
        let partialSearch = await getPartialResult(val, cat);
        if (partialSearch.length === 1 && partialSearch[0].upc === val) {
          data = await barcodeService(partialSearch[0].upc, cat);
          if (data.message) {
            alert(data.message);
          }

          const needsMealDetail =
            ([cat].includes(data.category) &&
              (data.is_ref ||
                (!data.is_ref &&
                  ((!data.is_own &&
                    !data.is_history &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt) ||
                    (data.is_own &&
                      data.number_of_contribute >= 4 &&
                      !data.show_prompt) ||
                    (data.is_history &&
                      data.number_of_contribute >= 4 &&
                      !data.show_prompt))))) ||
            (!data.is_ref &&
              ((!data.is_own &&
                data.is_history &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt) ||
                (data.is_own &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt) ||
                (data.is_history &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt)));

          dispatch({
            type: getSucceeded(EDIT_PAGE_BARCODE_READ),
            data: data,
            partialSearch,
          });
          if (needsMealDetail) {
            dispatch({
              type: EDIT_SYMPTOM_OPTION_SELECTED,
              item: data,
            });
          }
        } else {
          if (partialSearch.length === 0) {
            dispatch({
              type: getFailed(PARTIAL_RESULT_FOUND),
              upc: val,
            });
          } else {
            dispatch({
              type: getSucceeded(PARTIAL_RESULT_FOUND),
              partialSearch,
            });
          }
        }
      }
    } catch (e) {
      dispatch({
        type: getFailed(EDIT_PAGE_BARCODE_READ),
        upc: val,
      });
      console.log(e);
    }
    dispatch({
      type: getEnded(EDIT_PAGE_BARCODE_READ),
    });
  };
};
const onSubmitUpcImage = (image, cat = "02") => {
  return async (dispatch) => {
    let category = cat;
    dispatch({
      type: getStarted(EDIT_PAGE_BARCODE_READ_IMG),
    });
    try {
      const barcodeNum = await getBarcode(image);
      dispatch({
        type: getSucceeded(EDIT_PAGE_BARCODE_READ_IMG),
        data: barcodeNum,
      });
      dispatch({
        type: getStarted(EDIT_PAGE_BARCODE_READ),
      });
      try {
        let data = await barcodeService(barcodeNum.barcode, cat);
        if (data.message) {
          alert(data.message);
        } else {
          data = data;
        }

        const needsMealDetail =
          ([cat].includes(data.category) &&
            (data.is_ref ||
              (!data.is_ref &&
                ((!data.is_own &&
                  !data.is_history &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt) ||
                  (data.is_own &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt) ||
                  (data.is_history &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt))))) ||
          // (!data.is_ref &&
          //   ((!data.is_own &&
          //     data.is_history &&
          //     data.number_of_contribute >= 4 &&
          //     !data.show_prompt) ||
          //     (data.is_own &&
          //       data.number_of_contribute >= 4 &&
          //       !data.show_prompt) ||
          //     (data.is_history &&
          //       data.number_of_contribute >= 4 &&
          //       !data.show_prompt)));

          (!data.is_ref &&
            ((!data.is_own &&
              data.is_history &&
              data.number_of_contribute >= 4 &&
              !data.show_prompt)));

        dispatch({
          type: getSucceeded(EDIT_PAGE_BARCODE_READ),
          data: data,
        });
        if (needsMealDetail) {
          dispatch({
            type: EDIT_SYMPTOM_OPTION_SELECTED,
            item: data,
          });
        }
      } catch (e) {
        dispatch({
          type: getFailed(EDIT_PAGE_BARCODE_READ),
          upc: barcodeNum.barcode,
          message: e.message && e.message === "" ? "" : false,
        });
      }
      dispatch({
        type: getEnded(EDIT_PAGE_BARCODE_READ),
      });
    } catch (error) {
      dispatch({
        type: getFailed(EDIT_PAGE_BARCODE_READ_IMG),
        date: error,
      });
    }
  };
};
const clearEditSymptom = (action) => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_EDIT_SYMPTOMS,
      action,
    });
  };
};
const onChangeAlertStatus = (item) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ON_CHANGE_ALERT_STATUS,
        data: item,
      });
    } catch (error) { }
  };
};
const addGreyUPCToItemNameField = (barcode) => ({
  type: ADD_GREY_UPC_ITEM_NAME_FIELD,
  payload: barcode,
});
const setHHMMMode = (value) => ({
  type: SET_HHMM_MODE,
  value,
});
const resetContributeAlertState = () => ({
  type: RESET_CONTRIBUTE_ALERT_STATE,
});
const dismissEditSaveSuccess = () => ({ type: DISMISS_EDIT_SAVE_SUCCESS });

const clearModal = () => {
  return dispatch => {
    dispatch({
      type: RESET_MODAL
    });
  };
};

export default {
  editPageInitialization,
  symptomOptionSelected,
  categorySelected,
  searchNameOptions,
  clearEditSymptom,
  getSymptomList,
  symptomSelected,
  deleteSymptom,
  updateSymptom,
  onDateChange,
  onChangeSyptomEditForm,
  onChangeSearchForm,
  onDateChangeSearch,
  savePage,
  resetPage,
  searchFormChanger,
  symptomExport,
  bodyMapReturn,
  bodyMapStart,
  exportDateChanges,
  barcodeSearch,
  onSubmitUpcImage,
  onChangeAlertStatus,
  addGreyUPCToItemNameField,
  setHHMMMode,
  resetContributeAlertState,
  dismissEditSaveSuccess,
  clearModal,
};



// WEBPACK FOOTER //
// ./src/actions/editSymptomActions.js